import { BillingStatus } from '../payments.model';
export interface ContractorsMeTimesheetsDownloadParams {
  /**
   * format: date
   */
  startDate?: string;
  /**
   * format: date
   */
  endDate?: string;
  /**
   * format: int32
   */
  year?: number;

  status?: BillingStatus;
}
